import React from "react";

const DicomPage = () => {
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* OHIF viewer side */}
      <div style={{ flex: 2 }}>
        <object
          data="/ohif/index.html"
          type="text/html"
          style={{ width: "100%", height: "100%", border: "none" }}
          aria-label="OHIF Viewer"
        >
          OHIF Viewer failed to load.
        </object>


      </div>

      {/* Report side */}
      <div style={{ flex: 1, borderLeft: "1px solid #ddd", padding: "20px" }}>
        <h3>Patient Report</h3>
        <textarea
          style={{ width: "100%", height: "70%", resize: "none" }}
          placeholder="Write your findings here..."
        />
        <button className="btn btn-primary mt-3">Save Report</button>
      </div>
    </div>
  );
};

export default DicomPage;
